import styled from '@emotion/styled';
import { getTextColor } from 'style';
import breakpoints from 'theme/material/breakpoints';
import { isDarkMode } from 'utils/helpers';

export const DiscountDetails = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

export const SummaryAmountText = styled('div')(() => ({
  ...getTextColor().LIGHT_GRAY,
  fontWeight: 600,
  fontSize: 15,
  lineHeight: '20px',
  letterSpacing: -0.3,
}));

export const PromoCodeContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexFlow: 'initial',
  [breakpoints.down('md')]: {
    flexFlow: 'wrap',
  },
});

export const DiscountText = styled('div')({
  color: isDarkMode() ? '#5EBE5E' : '#24A83A',
  fontSize: 15,
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '20px',
  letterSpacing: '-0.3px',
});

export const ErrorDisplay = styled('div')({
  color: '#F00',
  fontStyle: 'italic',
  fontSize: 13,
  fontWeight: 400,
  lineHeight: '18px',
  letterSpacing: '-0.3px',
  marginLeft: 10,
  marginRight: 'auto',
  [breakpoints.down('md')]: {
    marginLeft: 0,
  },
});

export const PromoInputContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  flexFlow: 'initial',
  [breakpoints.down('md')]: {
    alignItems: 'initial',
    flexFlow: 'column',
  },
});
